export const getProfileValue = (profile, fieldNames) => {
  const fields = profile?.data ?? profile;
  const names = new Set(fieldNames);

  if (Array.isArray(fields)) {
    return fields.find((field) => names.has(field?.uniqueId ?? field?.name))
      ?.value;
  }

  for (const name of fieldNames) {
    const value = fields?.[name] ?? profile?.[name];
    if (value !== undefined && value !== null && value !== "") return value;
  }

  return null;
};

const hasPositiveNumericValue = (profile, fieldNames) => {
  const value = Number(getProfileValue(profile, fieldNames));
  return Number.isFinite(value) && value > 0;
};

export const hasValidProfileHeight = (profile) =>
  hasPositiveNumericValue(profile, [
    "height",
    "height_cm",
    "heightCm",
    "height_in",
  ]);

export const hasValidProfileWeight = (profile) =>
  hasPositiveNumericValue(profile, [
    "weight",
    "weight_kg",
    "weightKg",
    "weight_lb",
  ]);

export const hasRequiredTestPersonMeasurements = (profile) =>
  hasValidProfileHeight(profile) && hasValidProfileWeight(profile);
